import styled from 'styled-components';
import { getInvertedColor } from '@elfsight/widget-utils';
import { useSettings } from '@wu/widget-core';
import { APP_CLASSNAME_PREFIX } from '../../../constants';

export function Arrow({ rotate }) {
  const { navigationColor } = useSettings();
  const iconFillColor = getInvertedColor(navigationColor);

  return (
    <ArrowButton _backgroundColor={navigationColor} _rotate={rotate}>
      <ArrowIcon fillColor={iconFillColor} />
    </ArrowButton>
  );
}

const ArrowButton = styled.div.attrs({
  className: `${APP_CLASSNAME_PREFIX}-arrow-component`
})`
  width: 32px;
  height: 32px;
  border-radius: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 3;
  position: relative;
  transition: 0.3s ease background-color;
  background-color: ${({ _backgroundColor }) => _backgroundColor};

  & svg {
    opacity: 0.9;
    transition: 0.3s ease opacity;
    ${({ _rotate }) => _rotate && 'transform: rotateZ(-180deg)'};
  }

  &:hover svg {
    opacity: 1;
  }
`;

function ArrowIcon({ fillColor }) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill={fillColor}
      className={`${APP_CLASSNAME_PREFIX}-arrow-icon`}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.0404 1.95955C6.64988 1.56903 6.01671 1.56903 5.62619 1.95955C5.2657 2.32003 5.23797 2.88726 5.543 3.27956L5.62619 3.37376L10.253 7.99999L5.62619 12.6262C5.2657 12.9867 5.23797 13.5539 5.543 13.9462L5.62619 14.0404C5.98667 14.4009 6.5539 14.4286 6.94619 14.1236L7.0404 14.0404L12.3737 8.7071C12.7342 8.34661 12.7619 7.77938 12.4569 7.38709L12.3737 7.29288L7.0404 1.95955Z"
      />
    </svg>
  );
}
